/**
 * Module dependencies.
 */

import { Label as UiLabel } from 'app/components/ui/label';
import { cn } from 'app/lib/utils';
import React from 'react';

/**
 * `Props` type.
 */

type Props = {
  children: string;
};

/**
 * Export `Label` component.
 */

export function Label({ children }: Props): JSX.Element {
  return <UiLabel className={cn('mb-1.5 block text-sm font-medium text-foreground')}>{children}</UiLabel>;
}
